const scanCards = [
  {
    icon: "fa fa-search",
    title: "Basic Scan",
    description: "Quickly assess the most common vulnerabilities in your environment. Aimed at identifying obvious weaknesses like outdated software, misconfigurations, and common threats.",
    timestamp: "Last updated 2 days ago",
    scanType: "basic", // Unique identifier for scan type
  },
  {
  icon: "fa fa-mobile",
  title: "Mobile App Scan",
  description: "Performs a comprehensive analysis of Android APK files & Apple IPA files, checking for malware signatures, insecure permissions, embedded trackers, and potential vulnerabilities in the application’s code or configuration.",
  timestamp: "Last updated 1 day ago",
  scanType: "apk"
}
,
  {
    icon: "fa fa-code",
    title: "Advanced Scan",
    description: "A comprehensive vulnerability scan designed to detect advanced security issues, including zero-day exploits, advanced persistent threats (APTs), and complex configuration flaws.",
    timestamp: "Last updated 2 days ago",
    scanType: "advanced", // Added as it wasn't in the original list
  },
  // {
  //   icon: "fa fa-bug",
  //   title: "Malware Scan",
  //   description: "Detect malicious software, including trojans, ransomware, and worms, across your infrastructure. Helps identify infected systems and mitigate potential threats.",
  //   timestamp: "Last updated 4 days ago",
  //   scanType: "Malware",
  // },
  {
    icon: "fa fa-globe",
    title: "Web App Scan",
    description: "Scan your web applications for vulnerabilities such as SQL injection, cross-site scripting (XSS), and misconfigurations that could expose your app to threats.",
    timestamp: "Last updated 3 days ago",
    scanType: "webApp",
  },
  {
    icon: "fa fa-network-wired",
    title: "Network Scan",
    description: "Analyze your network for potential vulnerabilities, weak configurations, open ports, and other risks that could expose your infrastructure to attacks.",
    timestamp: "Last updated 1 day ago",
    scanType: "networkScan",
  },
  {
    icon: "fa fa-cloud",
    title: "Cloud Security Scan",
    description: "Assess the security posture of your cloud infrastructure, including misconfigurations, access control issues, and compliance gaps across cloud services and resources.",
    timestamp: "Last updated 2 days ago",
    scanType: "cloudSecurity",
  },
  {
    icon: "fa fa-database",
    title: "Database Scan",
    description: "Perform a deep scan of your database systems for security vulnerabilities, such as weak access controls, SQL injection flaws, and outdated versions.",
    timestamp: "Last updated 3 days ago",
    scanType: "databaseScan",
  },
  {
    icon: "fa fa-plug",
    title: "API Scan",
    description: "Identify vulnerabilities in your APIs such as insecure endpoints, missing authentication, and data leakage that could expose your systems to attacks.",
    timestamp: "Last updated 6 days ago",
    scanType: "apiScan",
  },
  {
    icon: "fa fa-code",
    title: "Code Scan",
    description: "Scan your application’s source code for security vulnerabilities, including buffer overflows, input validation issues, and insecure coding practices.",
    timestamp: "Last updated 3 days ago",
    scanType: "codeScan",
  },
  {
    icon: "fa fa-cogs",
    title: "Configuration Scan",
    description: "Evaluate system configurations to identify weaknesses such as misconfigured servers, insecure default settings, or open ports that could lead to potential exploits.",
    timestamp: "Last updated 4 days ago",
    scanType: "configScan",
  },
  {
    icon: "fa fa-search",
    title: "SBOM",
    description: "Generate and analyze the Software Bill of Materials (SBOM) to track the components and dependencies used within your software, helping identify vulnerabilities in third-party libraries.",
    timestamp: "Last updated 2 days ago",
    scanType: "SBOM", // Unique identifier for scan type
  },
  {
    icon: "fa fa-search",
    title: "SCA",
    description: "Perform Software Composition Analysis (SCA) to identify vulnerabilities in open-source libraries and third-party components used within your software stack.",
    timestamp: "Last updated 2 days ago",
    scanType: "SCA", // Unique identifier for scan type
  },
  {
    icon: "fa fa-box",
    title: "Container Security",
    description: "Analyze containerized applications for security misconfigurations, vulnerabilities in container images, and potential risks in container orchestration platforms like Kubernetes.",
    timestamp: "Last updated 3 days ago",
    scanType: "CONTAINER", // Unique identifier for scan type
  }
];


export default scanCards;
